export default __webpack_public_path__ + "static/media/iso-aden.fba58197.png";